<template>
  <DsShowcase title="InputColorPlay" description="Seletor de cor.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model: string</code> — valor em hexadecimal</p>
      <div class="tw:max-w-lg tw:space-y-4">
        <InputColorPlay v-model="color1" label="Cor primária" />
        <p class="tw:text-xs tw:opacity-50">Valor: {{ color1 }}</p>
      </div>
    </section>

    <!-- Múltiplas instâncias -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Múltiplos</h2>
      <div class="tw:max-w-lg tw:space-y-4">
        <InputColorPlay v-model="color2" label="Cor de fundo" />
        <InputColorPlay v-model="color3" label="Cor do texto" />
        <div class="tw:p-4 tw:rounded-lg tw:text-sm" :style="{ backgroundColor: color2, color: color3 }">
          Preview com as cores selecionadas
        </div>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { InputColorPlay } from '@/components/atomic'

const color1 = ref('#3182ce')
const color2 = ref('#1a202c')
const color3 = ref('#ffffff')
</script>
